import React from 'react';
import { Outlet } from 'react-router-dom';
import allRouter from "../router/routerConfig";
import { store } from '@/store/index';
import { setChildrenMenu } from '@/store/user/userMenu'
import SystemLayout from '@/components/Layout';
import ErrorBoundary from '@/components/ErrorBoundary';
import { authLoader } from '@/utils/authLoader';

const PUBLIC_ROUTE_PATHS = new Set(['/', '/login', '*']);

/** 各平台共用同一套 SystemLayout，避免 /tb → /jd 切换时整棵侧栏卸载重挂。 */
export function shareSystemLayout(routes: any[]) {
  const publicRoutes: any[] = [];
  const authRoutes: any[] = [];
  routes.forEach((route) => {
    if (PUBLIC_ROUTE_PATHS.has(route.path)) {
      publicRoutes.push(route);
      return;
    }
    authRoutes.push({
      ...route,
      element: React.createElement(Outlet),
      loader: undefined,
      errorElement: undefined,
    });
  });
  if (authRoutes.length === 0) {
    return routes;
  }
  return [
    ...publicRoutes.filter((route) => route.path !== '*'),
    {
      element: React.createElement(SystemLayout),
      loader: authLoader,
      shouldRevalidate: () => false,
      errorElement: React.createElement(ErrorBoundary),
      children: authRoutes,
    },
    ...publicRoutes.filter((route) => route.path === '*'),
  ];
}
//根据数据返回设置路由
export function routerFormatter(type: boolean, menu: any) {
  // let menu = store.getState().menu.menu//获取全部路由（包括页面内的三级路由
  let roleCode = store.getState().user.roleCode
  let username = store.getState().user.username
  let menuList: any = []
  let routerList: any = []
  let finalList: any = []
  let ids: any = []
  menu.forEach((val: any) => {
    //这里取二级路由的path，与allRoter中handle的path做对比，得出要渲染的路由
    let res = val.children.map((item: any) => item.path) || []
    menuList.push(...res)
    ids.push(val, ...val.children)
  })
  menuList.forEach((val: any) => {
    let element: any = {}
    element[val] = []
    menu.forEach((el: any) => {
      let arr = el.children.filter((item: any) => {
        return item.path === val
      })
      element[val].push(...arr)
    })
    routerList.push(element)
  })
  let obj: any = {
    children: []
  }
  let rerouter: any = []
  let finalRouter: any = []//请求返回的路由
  allRouter.forEach((val: any) => {
    if (val.path !== '/' && val.path !== '/login') {
      // console.log(val.children);
      obj = {
        ...val
      }
      obj.children = []
      val.children?.forEach((item: any) => {
        if (menuList.includes(item.handle?.path)) {
          if (routerList.filter((element: any) => element[item.handle.path]).length > 0) {
            let routerItem = routerList.filter((element: any) => element[item.handle.path])[0]
            let finalItem: any = {}
            finalItem[item.path] = Object.values(routerItem)[0]
            finalList.push(finalItem)
          }
          //保存id
          ids.forEach((id: any) => {
            if (id.path === item.handle.path) {
              item.id = id.id
            }
          })
          obj.children.push(item)
          if (!rerouter.includes(val.path)) {
            finalRouter.push(obj)
            rerouter.push(val.path)
          }
        }
      })
    }
    else {
      obj = {
        ...val
      }
      finalRouter.push(obj)
    }
  })
  //保存三级子路由
  store.dispatch(setChildrenMenu(finalList))

  // 无论是否登录，都注册所有路由
  // 受保护的路由通过 loader (authLoader) 来检查 token，如果没有 token 会自动重定向到登录页
  let formattedRoutes = allRouter.map(val => {
    // 保留 index 路由（index: true）和有 path 的路由
    val.children = val.children?.filter((item: any) => item.path || item.index)
    return val
  })
  //写死运营只给开放数据审核页面
  if (roleCode === 'ROLE_YUNYING') {
    formattedRoutes = formattedRoutes.filter((val: any) => {
      return val.path === '/' || val.path === '/login' || val.path === '/data-audit' || val.path === '/dy' || val.path === '/kuaishou' || val.path === '/tools'
        || val.path === '/wechat'
    })
    formattedRoutes = formattedRoutes.map((val: any) => {
      if (val.path === '/kuaishou') {
        val.children = val.children?.filter((item: any) => item.path === 'kuaishou-shop-list')
      }
      return val
    })
  }
  //写死技术给除了开放用户管理、数据任务、系统设置页面外其他页面
  if (roleCode === 'ROLE_TECH') {
    formattedRoutes = formattedRoutes.filter((val: any) => {
      return val.path !== '/users' && val.path !== '/data-task' && val.path !== '/setting'
    })
  }
  if (username === 'yihui') {
    formattedRoutes.push(allRouter.filter((val: any) => val.path === '/tb')[0])
  }
  if (username === 'youshujun') {
    formattedRoutes = formattedRoutes.filter((val: any) => {
      return val.path == '/' || val.path == '/tools' || val.path == '/login'
    })
  }
  if (type) {
    //todo登录的情况下的路由
    return formattedRoutes//所有路由
    // return finalRouter
  } else {
    // 没登录时也返回所有路由，但受保护的路由会通过 loader 重定向到登录页
    // 这样可以避免 404 错误，而是正确重定向到登录页
    return formattedRoutes
  }
}
//根据返回菜单设置菜单栏
export function menuFormatter() {
  let menu = store.getState().menu.currentmenu//获取当前路由
  let newMenu: any = []
  menu.forEach((val: any) => {
    if (val.path !== '/' && val.path !== '/login') {
      let item: any = allRouter.filter(item => item.path === val.path)[0]
      let obj = {
        key: val.path,
        label: val?.handle?.title,
        icon: item?.handle?.icon,
        children: val.children?.map((item: any) => {
          return { key: `${val.path}/${item.path}`, label: item.handle.title }
        })
          .filter((item: any) => item.label)

      }
      newMenu.push(obj)
    }
  })
  return newMenu

}